// import { Grid } from "@mui/material";
// import React, { useEffect, useState } from "react";
// import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
// import WSButton from "../../../Components/Button/WSButton";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import { IHeaderRows } from "../../../Components/Filter/WSHeaderFilter";
// import { useNavigate } from "react-router-dom";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import TechnicianDrawer from "./TechnicianDrawer";
// import { useForm } from "react-hook-form";

// export const TechnicianManagement:React.FC<any>=React.memo((props)=>{
//   const { control, register, setValue, reset,handleSubmit} = useForm();

//   const filters = ["All", "Active","On Route","Assigned","Offline"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);
// const [open, setOpen] = React.useState(false);
//   const [formComponent, setFormComponent] = useState<any>()
//   useEffect(() => { updateMainHeader('Technician Management'); }, [])
  
  
//      breadCrumbsStore.updateBreadCrumbs([
//                 { 'Technician Management': 'technician-management/list' },
//     ]);
//   const columns: IColumns[] = [
//     {
//       header: "Technician Profile ",
//       fieldName: "",
//       type: "default",
//       // sortable: true
//     },
//     {
//       header: "Current Assignment",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Todays Performance",
//       fieldName: "price",
//       type: "default",
//     },
    
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"].filter(Boolean),
//       // actionCallback: (action, row) => handleAction(action, row),
//       // hideSelectedActions: {
//       //     fieldToHide: [
//       //         {
//       //             field: 'status',
//       //             hideValue: ['Incomplete'],
//       //             hideActions: ['Edit']
//       //         },
//       //         // {
//       //         //     field: 'profileStatus',
//       //         //     hideValue: ['Approved'],
//       //         //     hideActions: ['Approve']
//       //         // }
//       //     ]
//       // }
//     },
//   ];
 

//    const handleClick= ()=>{
//  const form: any = <TechnicianDrawer
//         id="technicianAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}
//       />
//       setFormComponent(form)
//       setTimeout(() => {
//         setOpen(true)
//       }, 10);
//     }
//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Technicians"
//             value="24"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Active Now"
//             value="20"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="On Task"
//             value="12"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
     
//         <Grid item sm={9}>
//           <WSFilterButtonGroup
//             options={filters}
//             selected={selectedFilter}
//             onChange={(value) => {
//               setSelectedFilter(value);
//               // handleFilter(value);
//             }}
//           />
//         </Grid>
//         <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
//           <WSButton
//             id="btnAddTechnician"
//             label="Add Technician"
//             startIcon={<WSIcons.AddIcon />}
//             onClick={handleClick}
//             sx={{
//               borderRadius: "999px", // pill shape
//               backgroundColor: "#098963!important", // green background
//               textTransform: "none", // prevent uppercase
//               fontWeight: 500,
//               height: "35px!important",
//               fontSize: "0.875rem!important",
//               paddingX: 3,
//               paddingY: 1,
//               "&:hover": {
//                 backgroundColor: "#087654!important",
//               },
//             }}
//           />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         {
//           <Grid item sm={12}>
//             <WSDataGridNew
//               columns={columns}
//               id="technicianListGrid"
//               title="Products"
//               exportCsv={true}
//               addButton={{ label: "New", color: "secondary" }}
//               onAddButtonClick={handleClick}
//               searchBox={{ fieldName: "name" }}
//               gridHeaderSx={{
//                 backgroundColor: "whitesmoke",
//                 border: "1px solid whitesmoke",
//               }}
//             />
//           </Grid>
//         }

//           <SwipeableDrawerForm anchor="right" title={''}
//                 openForm={open} isEdit={true}
//                 formComponent={<form onSubmit={handleSubmit(handleClick)}>
//                   {formComponent}
//                 </form>}
//                 onClose={() => { reset(); setOpen(false); setFormComponent(null) }}
                
//               />
//       </Grid>
//     </>
//   );
// });










// import { Grid } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
// import WSButton from "../../../Components/Button/WSButton";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import { useNavigate } from "react-router-dom";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import TechnicianDrawer from "./TechnicianDrawer";
// import { useForm } from "react-hook-form";
// import http from "../../../commonFunctions/httpClient";
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

// interface Technician {
//   id: string;
//   profileName: string;
//   profileImage?: string;
//   mode: string;
//   price: string;
//   status: string;
//   actions: string;
// }

// export const TechnicianManagement: React.FC<any> = React.memo((props) => {
//   const { control, register, setValue, reset, handleSubmit } = useForm();
//   const navigate = useNavigate();

//   const filters = ["All", "Active", "On Route", "Assigned", "Offline"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);
//   const [open, setOpen] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [vendorId, setVendorId] = useState<string>("");
//   const [technicians, setTechnicians] = useState<Technician[]>([]);
//   const [loading, setLoading] = useState(true);

//   // ✅ Get vendorId from localStorage
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   // ✅ Fetch technicians data
//   // ✅ FIXED fetchTechnicians - Replace your current one
// const fetchTechnicians = useCallback(async () => {
//   if (!vendorId) {
//     console.log("⏳ Waiting for vendorId...");
//     setLoading(false);
//     return;
//   }

//   try {
//     setLoading(true);
//     console.log("📡 FETCHING TECHNICIANS FOR VENDOR:", vendorId);
    
//     const response: any = await http.get(`/pharmacy/DeliveryPerson/${vendorId}/delivery-person`);
//     console.log("👷 FULL API RESPONSE:", response);
    
//     let data: Technician[] = [];
    
//     // ✅ CORRECT STRUCTURE: response.data (single object)
//     if (response?.success && response?.data) {
//       const rawData = Array.isArray(response.data) 
//         ? response.data 
//         : [response.data]; // Wrap single object in array
      
//       data = rawData.map((tech: any) => ({
//         id: tech.id || tech.vendorId,
//         profileName: tech.name || "Unknown",
//         profileImage: tech.profileImage,
//         mode: tech.workingHours || "8 hours",
//         price: tech.experience?.toString() || "1",
//         status: tech.status || "Active",
//         actions: tech.id || tech.vendorId
//       })).filter(Boolean);
//     }
    
//     console.log("👷 RAW API DATA:", response?.data);
//     console.log("👷 TRANSFORMED DATA:", data);
//     console.log("👷 DATA LENGTH:", data.length);
//     setTechnicians(data);
//   } catch (error: any) {
//     console.error("💥 API ERROR:", error);
//     setTechnicians([]);
//   } finally {
//     setLoading(false);
//   }
// }, [vendorId]);



//   // ✅ Fetch data when vendorId changes
//   useEffect(() => {
//     fetchTechnicians();
//   }, [fetchTechnicians]);

//   useEffect(() => { 
//     updateMainHeader('Technician Management'); 
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([
//     { 'Technician Management': 'technician-management/list' },
//   ]);

//   const columns: IColumns[] = [
//     {
//       header: "Technician Profile",
//       fieldName: "profileName",
//       type: "default",
//     },
//     {
//       header: "Current Assignment",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Todays Performance",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["Edit"],
//     },
//   ];

//   const handleClick = () => {
//     const form: any = (
//       <TechnicianDrawer
//         id="technicianAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => { 
//           reset(); 
//           setOpen(false); 
//           setFormComponent(null); 
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => {
//       setOpen(true);
//     }, 10);
//   };

//   if (loading) {
//     return (
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//           <div>Loading technicians...</div>
//         </Grid>
//       </Grid>
//     );
//   }

//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Technicians"
//             value={technicians.length.toString()}
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Active Now"
//             value="20"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="On Task"
//             value="12"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={9}>
//           <WSFilterButtonGroup
//             options={filters}
//             selected={selectedFilter}
//             onChange={(value) => {
//               setSelectedFilter(value);
//             }}
//           />
//         </Grid>
//         <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
//           <WSButton
//             id="btnAddTechnician"
//             label="Add Technician"
//             startIcon={<WSIcons.AddIcon />}
//             onClick={handleClick}
//             sx={{
//               borderRadius: "999px",
//               backgroundColor: "#098963!important",
//               textTransform: "none",
//               fontWeight: 500,
//               height: "35px!important",
//               fontSize: "0.875rem!important",
//               paddingX: 3,
//               paddingY: 1,
//               "&:hover": {
//                 backgroundColor: "#087654!important",
//               },
//             }}
//           />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12}>
//           <WSDataGridNew
//             columns={columns}
//             id="technicianListGrid"
//             title={`Technicians - Vendor ${vendorId.substring(0, 8)}... (${technicians.length})`}
//             exportCsv={true}
//             data={technicians}
//             addButton={{ label: "New Technician", color: "secondary" }}
//             onAddButtonClick={handleClick}
//             searchBox={{ fieldName: "profileName" }}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
          
//           {/* ✅ Debug - Remove in production */}
//           <div style={{ marginTop: 20, padding: 15, background: '#e3f2fd', borderRadius: 8 }}>
//             <strong>Technicians loaded:</strong> <span style={{color: technicians.length > 0 ? 'green' : 'red'}}>{technicians.length}</span>
//           </div>
//         </Grid>

//         <SwipeableDrawerForm 
//           anchor="right" 
//           title={''}
//           openForm={open} 
//           isEdit={true}
//           formComponent={
//             <form onSubmit={handleSubmit(handleClick)}>
//               {formComponent}
//             </form>
//           }
//           onClose={() => { 
//             reset(); 
//             setOpen(false); 
//             setFormComponent(null); 
//           }}
//         />
//       </Grid>
//     </>
//   );
// });











// import { Grid } from "@mui/material";
// import React, { useEffect, useState, useCallback } from "react";
// import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
// import WSButton from "../../../Components/Button/WSButton";
// import { WSIcons } from "../../../commonFunctions/iIcons";
// import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
// import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
// import { useNavigate } from "react-router-dom";
// import { updateMainHeader } from "../../../commonFunctions/CommonFunctions";
// import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
// import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
// import TechnicianDrawer from "./TechnicianDrawer";
// import { useForm } from "react-hook-form";
// import http from "../../../commonFunctions/httpClient";
// import { getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";

// interface Technician {
//   id: string;
//   profileName: string;
//   profileImage?: string;
//   mode: string;
//   price: string;
//   status: string;
//   actions: string;
// }

// export const TechnicianManagement: React.FC<any> = React.memo((props) => {
//   const { control, register, setValue, reset, handleSubmit } = useForm();
//   const navigate = useNavigate();

//   const [drawerOpen, setDrawerOpen] = useState(false);
//   const [formComponent, setFormComponent] = useState<any>();
//   const [vendorId, setVendorId] = useState<string>("");
//   const [technicians, setTechnicians] = useState<Technician[]>([]);
//   const [loading, setLoading] = useState(true);
//   const filters = ["All", "Active", "On Route", "Assigned", "Offline"];
//   const [selectedFilter, setSelectedFilter] = useState(filters[0]);

//   // ✅ Get vendorId from localStorage
//   useEffect(() => {
//     const userId = getLocalValue(LoacalVariables.UserId);
//     setVendorId(userId || "");
//   }, []);

//   // ✅ Fetch technicians data
//   const fetchTechnicians = useCallback(async () => {
//     if (!vendorId) {
//       console.log("⏳ Waiting for vendorId...");
//       setLoading(false);
//       return;
//     }

//     try {
//       setLoading(true);
//       console.log("📡 FETCHING TECHNICIANS FOR VENDOR:", vendorId);
      
//       const response: any = await http.get(`/pharmacy/DeliveryPerson/${vendorId}/delivery-person`);
//       console.log("👷 FULL API RESPONSE:", response);
      
//       let data: Technician[] = [];
      
//       if (response?.success && response?.data) {
//         const rawData = Array.isArray(response.data) 
//           ? response.data 
//           : [response.data];
         
//         data = rawData.map((tech: any) => ({
//           id: tech.id || tech.vendorId,
//           profileName: tech.name || "Unknown",
//           profileImage: tech.profileImage,
//           mode: tech.workingHours || "8 hours",
//           price: tech.experience?.toString() || "1",
//           status: tech.status || "Active",
//           actions: tech.id || tech.vendorId
//         })).filter(Boolean);
//       }
      
//       console.log("👷 TRANSFORMED DATA:", data);
//       setTechnicians(data);
//     } catch (error: any) {
//       console.error("💥 API ERROR:", error);
//       setTechnicians([]);
//     } finally {
//       setLoading(false);
//     }
//   }, [vendorId]);

//   useEffect(() => {
//     fetchTechnicians();
//   }, [fetchTechnicians]);

//   useEffect(() => { 
//     updateMainHeader('Technician Management'); 
//   }, []);

//   breadCrumbsStore.updateBreadCrumbs([
//     { 'Technician Management': 'technician-management/list' },
//   ]);

//   // ✅ DELETE HANDLER
//   const handleDelete = async (id?: string | number) => {
//     try {
//       if (!window.confirm("Are you sure you want to delete this technician?")) {
//         return;
//       }

//       console.log("🗑️ DELETING TECHNICIAN:", id);
//       const response: any = await http.del(`pharmacy/DeliveryPerson/${id}`);
//       console.log("🗑️ DELETE RESPONSE:", response);
      
//       if (response?.success) {
//         alert(response?.message || 'Technician deleted successfully!');
//         await fetchTechnicians(); // Refresh data
//       } else {
//         alert(response?.message || 'Something went wrong');
//       }
//     } catch (error: any) {
//       console.error("💥 DELETE ERROR:", error);
//       alert(error?.message || 'Failed to delete technician');
//     }
//   };

//   // ✅ ACTION HANDLER - ONLY View + Delete
//   const handleAction = async (action: string, row: Technician) => {
//     console.log("🔧 ACTION:", action, "ROW:", row);
    
//     if (action === "View") {
//       // ✅ Navigate to pharmacy-order-details/{id}
//       navigate(`/pharmacy-order-details/${row.id}`);
//     } 
//     else if (action === "Delete") {
//       handleDelete(row.id);
//     }
//   };

//   // ✅ Add Technician handler
//   const handleClick = () => {
//     const form: any = (
//       <TechnicianDrawer
//         id="technicianAdd"
//         control={control}
//         register={register}
//         reset={reset}
//         setValue={setValue}
//         onCancel={() => { 
//           reset(); 
//           setDrawerOpen(false); 
//           setFormComponent(null); 
//         }}
//       />
//     );
//     setFormComponent(form);
//     setTimeout(() => {
//       setDrawerOpen(true);
//     }, 10);
//   };

//   if (loading) {
//     return (
//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
//           <div>Loading technicians...</div>
//         </Grid>
//       </Grid>
//     );
//   }

//   const columns: IColumns[] = [
//     {
//       header: "Technician Profile",
//       fieldName: "profileName",
//       type: "default",
//     },
//     {
//       header: "Current Assignment",
//       fieldName: "mode",
//       type: "default",
//     },
//     {
//       header: "Todays Performance",
//       fieldName: "price",
//       type: "default",
//     },
//     {
//       header: "Status",
//       fieldName: "status",
//       type: "status",
//     },
//     {
//       header: "Actions",
//       fieldName: "actions",
//       type: "action",
//       actions: ["View", "Delete"], // ✅ ONLY View + Delete (NO Edit)
//       actionCallback: (action, row) => handleAction(action, row),
//     },
//   ];

//   return (
//     <>
//       <Grid container spacing={2}>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Total Technicians"
//             value={technicians.length.toString()}
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="Active Now"
//             value="20"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={3}>
//           <WSDashboardCard
//             title="On Task"
//             value="12"
//             percentage="+2.5%"
//             bottomIcon={<WSIcons.TrendingUp />}
//             icon={<WSIcons.OutOfStockIcon sx={{ color: "red" }} />}
//             onClick={() => console.log("Card clicked")}
//           />
//         </Grid>
//         <Grid item sm={9}>
//           <WSFilterButtonGroup
//             options={filters}
//             selected={selectedFilter}
//             onChange={(value) => {
//               setSelectedFilter(value);
//             }}
//           />
//         </Grid>
//         <Grid item sm={3} display="flex" justifyContent={"flex-end"}>
//           <WSButton
//             id="btnAddTechnician"
//             label="Add Technician"
//             startIcon={<WSIcons.AddIcon />}
//             onClick={handleClick}
//             sx={{
//               borderRadius: "999px",
//               backgroundColor: "#098963!important",
//               textTransform: "none",
//               fontWeight: 500,
//               height: "35px!important",
//               fontSize: "0.875rem!important",
//               paddingX: 3,
//               paddingY: 1,
//               "&:hover": {
//                 backgroundColor: "#087654!important",
//               },
//             }}
//           />
//         </Grid>
//       </Grid>

//       <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
//         <Grid item sm={12}>
//           <WSDataGridNew
//             columns={columns}
//             id="technicianListGrid"
//             title={`Technicians - Vendor ${vendorId.substring(0, 8)}... (${technicians.length})`}
//             exportCsv={true}
//             data={technicians}
//             addButton={{ label: "New Technician", color: "secondary" }}
//             onAddButtonClick={handleClick}
//             searchBox={{ fieldName: "profileName" }}
//             gridHeaderSx={{
//               backgroundColor: "whitesmoke",
//               border: "1px solid whitesmoke",
//             }}
//           />
          
//           {/* Debug info */}
//           <div style={{ marginTop: 20, padding: 15, background: '#e3f2fd', borderRadius: 8 }}>
//             <strong>Technicians loaded:</strong> <span style={{color: technicians.length > 0 ? 'green' : 'red'}}>{technicians.length}</span>
//           </div>
//         </Grid>

//         <SwipeableDrawerForm 
//           anchor="right" 
//           title={''}
//           openForm={drawerOpen} 
//           isEdit={true}
//           formComponent={
//             <form onSubmit={handleSubmit(handleClick)}>
//               {formComponent}
//             </form>
//           }
//           onClose={() => { 
//             reset(); 
//             setDrawerOpen(false); 
//             setFormComponent(null); 
//           }}
//         />
//       </Grid>
//     </>
//   );
// });






import { Grid, Box, Typography } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import WSDataGridNew, { IColumns } from "../../../Components/DataGrid/WSDataGridNew";
import WSButton from "../../../Components/Button/WSButton";
import { WSIcons } from "../../../commonFunctions/iIcons";
import WSFilterButtonGroup from "../../../Components/Filter/WSFilterButtonGroup";
import WSDashboardCard from "../../../Components/CardListing/WSDashboardCard";
import { useNavigate } from "react-router-dom";
import { updateMainHeader, getLocalValue, LoacalVariables } from "../../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../../Components/BreadCrumbs/BreadCrumbsListner";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import TechnicianDrawer from "./TechnicianDrawer";
import { useForm } from "react-hook-form";
import http from "../../../commonFunctions/httpClient";

interface TechnicianSummary {
  totalDeliveryPersons: number;
  activeDeliveryPersons: number;
  onTaskDeliveryPersons: number;
}

interface Technician {
  id: string;
  profileName: string;
  profileImage?: string;
  mode: string;
  price: string;
  status: string;
  actions: string;
  contact?: string;
  qualification?: string;
  experience?: string;
}

export const TechnicianManagement: React.FC<any> = React.memo((props) => {
  const { control, register, setValue, reset } = useForm<any>();
  const navigate = useNavigate();

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [formComponent, setFormComponent] = useState<any>();
  const [vendorId, setVendorId] = useState<string>("");
  const [technicians, setTechnicians] = useState<Technician[]>([]);
  const [filteredTechnicians, setFilteredTechnicians] = useState<Technician[]>([]);
  
  const [summary, setSummary] = useState<TechnicianSummary>({
    totalDeliveryPersons: 0,
    activeDeliveryPersons: 0,
    onTaskDeliveryPersons: 0
  });
  const [loading, setLoading] = useState(true);
  const [dataReady, setDataReady] = useState(false);
  
  const [filterCounts, setFilterCounts] = useState({
    All: 0,
    Active: 0,
    "On Route": 0,
    Assigned: 0,
    Offline: 0
  });
  
  const filters = ["All", "Active", "On Route", "Assigned", "Offline"];
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  // ✅ Load vendorId on mount
  useEffect(() => {
    const userId = getLocalValue(LoacalVariables.UserId);
    if (userId) {
      console.log('🚀 Loading vendorId:', userId);
      setVendorId(userId);
    }
  }, []);

  const fetchTechnicians = useCallback(async () => {
    if (!vendorId) {
      setLoading(false);
      setDataReady(false);
      return;
    }

    try {
      setLoading(true);
      console.log("📡 FETCHING TECHNICIANS:", vendorId);
      const response: any = await http.get(`pharmacy/DeliveryPerson/${vendorId}/delivery-person`);
      
      console.log('✅ FULL API RESPONSE:', response);
      
      let data: Technician[] = [];
      if (response?.success && Array.isArray(response.data)) {
        data = response.data.map((tech: any) => {
          let formattedAssignment = "No Assignment";
          if (tech.currentAssignment) {
            try {
              const assignment = typeof tech.currentAssignment === 'string' 
                ? JSON.parse(tech.currentAssignment) 
                : tech.currentAssignment;
              
              formattedAssignment = [
                assignment.orderId || '',
                assignment.customerName || '',
                assignment.address || '',
                assignment.assignedAt ? new Date(assignment.assignedAt).toLocaleString() : ''
              ].filter(Boolean).join('\n');
            } catch (e) {
              formattedAssignment = tech.currentAssignment;
            }
          }

          return {
            id: tech.technicianId,
            profileName: tech.name,
            profileImage: tech.profileImage ? `https://melpapi.reobeen.com${tech.profileImage}` : undefined,
            mode: formattedAssignment, 
            price: `${tech.todaysPerformance?.ordersCompleted || 0} orders`,
            status: tech.status || "Offline",
            actions: tech.technicianId,
            contact: tech.contact,
            qualification: tech.qualification,
            experience: `${tech.experience || 0} yrs`
          };
        });
      }
      
      console.log('✅ Loaded technicians:', data.length);
      setTechnicians(data);
      setDataReady(true);
      
      const counts = {
        All: data.length,
        Active: data.filter(t => t.status === "Active").length,
        "On Route": data.filter(t => t.status === "On Route").length,
        Assigned: data.filter(t => t.status === "Assigned").length,
        Offline: data.filter(t => t.status === "Offline").length
      };
      setFilterCounts(counts);
      setFilteredTechnicians(data);
      
    } catch (error: any) {
      console.error("💥 API ERROR:", error);
      setTechnicians([]);
      setFilterCounts({ All: 0, Active: 0, "On Route": 0, Assigned: 0, Offline: 0 });
      setFilteredTechnicians([]);
      setDataReady(true);
    } finally {
      setLoading(false);
    }
  }, [vendorId]);

  useEffect(() => {
    if (vendorId) {
      fetchTechnicians();
    }
  }, [vendorId, fetchTechnicians]);

  const fetchTechnicianSummary = useCallback(async () => {
    if (!vendorId) return;
    try {
      const response: any = await http.get(`pharmacy/DeliveryPerson/${vendorId}/technician-summary`);
      if (response?.success && response?.data) {
        setSummary({
          totalDeliveryPersons: response.data.totalDeliveryPersons || 0,
          activeDeliveryPersons: response.data.activeDeliveryPersons || 0,
          onTaskDeliveryPersons: response.data.onTaskDeliveryPersons || 0
        });
      }
    } catch (error: any) {
      console.error("💥 Summary Error:", error);
    }
  }, [vendorId]);

  const handleFilterChange = useCallback((value: string) => {
    const originalFilter = value.replace(/\(\d+\)$/, '').trim();
    console.log('🔄 Filter changed to:', originalFilter);
    setSelectedFilter(originalFilter);

    if (originalFilter === "All") {
      setFilteredTechnicians(technicians);
    } else {
      const filtered = technicians.filter(tech => tech.status === originalFilter);
      setFilteredTechnicians(filtered);
    }
  }, [technicians]);

  const getFilterLabel = useCallback((filter: string) => 
    `${filter}(${filterCounts[filter as keyof typeof filterCounts] || 0})`, 
  [filterCounts]);

  useEffect(() => { 
    updateMainHeader('Technician Management'); 
  }, []);

  useEffect(() => {
    breadCrumbsStore.updateBreadCrumbs([
      { 'Technician Management': 'technician-management/list' },
    ]);
  }, []);

  const handleDelete = useCallback(async (id?: string | number) => {
    if (!id || !window.confirm('Delete technician?')) return;
    
    const idStr = id.toString();
    try {
      console.log("🗑️ DELETING:", idStr);
      const response: any = await http.del(`pharmacy/DeliveryPerson/${idStr}`);
      
      if (response?.success !== false) {
        alert('✅ Technician deleted successfully!');
        await Promise.all([fetchTechnicians(), fetchTechnicianSummary()]);
      } else {
        alert('❌ Delete failed');
      }
    } catch (error: any) {
      console.error("💥 DELETE ERROR:", error);
      alert('❌ Failed to delete');
    }
  }, [vendorId, fetchTechnicians, fetchTechnicianSummary]);

  const handleAction = useCallback((action: string, row: Technician) => {
    console.log("🔧 ACTION:", action, "ROW:", row);
    
    switch (action) {
      case "View":
        navigate(`/technician-details/${row.id}`);
        break;
      case "Order":
        navigate(`/assign-order/order/${row.id}`);
        break;
      case "Delete":
        handleDelete(row.id);
        break;
      default:
        console.warn("Unknown action:", action);
    }
  }, [navigate, handleDelete]);

  const handleClick = () => {
    const form: any = (
      <TechnicianDrawer
        id="technicianAdd"
        control={control}
        register={register}
        reset={reset}
        setValue={setValue}
        onCancel={() => { 
          reset(); 
          setDrawerOpen(false); 
          setFormComponent(null); 
        }}
        onSuccess={fetchTechnicians}
      />
    );
    setFormComponent(form);
    setTimeout(() => setDrawerOpen(true), 10);
  };

  if (loading) {
    return (
      <Grid container spacing={2} mt={1} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12} display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <div>Loading technicians...</div>
        </Grid>
      </Grid>
    );
  }

  const columns: IColumns[] = [
    { header: "Technician Profile", fieldName: "profileName", type: "default" },
    { header: "Current Assignment", fieldName: "mode", type: "default" },
    { header: "Todays Performance", fieldName: "price", type: "default" },
    { header: "Status", fieldName: "status", type: "status" },
    { 
      header: "Actions", 
      fieldName: "actions", 
      type: "action", 
      actions: ["View", "Order", "Delete"],
      actionCallback: (action, row) => handleAction(action, row as Technician),
    },
  ];

  return (
    <>
      <Grid container spacing={2}>
        <Grid item sm={3}>
          <WSDashboardCard 
            title="Total Technicians" 
            value={filterCounts.All.toString()} 
            percentage="" 
            bottomIcon={<WSIcons.TrendingUp />} 
            icon={<WSIcons.ShoppingCartIcon sx={{ color: "#098963" }} />} 
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard 
            title="Active Now" 
            value={filterCounts.Assigned.toString()} 
            percentage="" 
            bottomIcon={<WSIcons.TrendingUp />} 
            icon={<WSIcons.InStockIcon sx={{ color: "#098963" }} />} 
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard 
            title="Offline" 
            value={filterCounts.Offline.toString()} 
            percentage="" 
            bottomIcon={<WSIcons.TrendingUp />} 
            icon={<WSIcons.OutOfStockIcon sx={{ color: "#ff9800" }} />} 
          />
        </Grid>
        <Grid item sm={3}>
          <WSDashboardCard 
            title="List Loaded" 
            value={technicians.length.toString()} 
            percentage="" 
            bottomIcon={<WSIcons.TrendingUp />}
            icon={<WSIcons.ShoppingCartIcon sx={{ color: "#757575" }} />} 
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2}>
        <Grid item sm={9}>
          <WSFilterButtonGroup 
            options={filters.map(filter => getFilterLabel(filter))}
            selected={getFilterLabel(selectedFilter)}
            onChange={handleFilterChange}
          />
        </Grid>
        <Grid item sm={3} display="flex" justifyContent="flex-end">
          <WSButton
            id="btnAddTechnician"
            label="Add Technician"
            startIcon={<WSIcons.AddIcon />}
            onClick={handleClick}
            sx={{
              borderRadius: "999px",
              backgroundColor: "#098963!important",
              textTransform: "none",
              fontWeight: 500,
              height: "35px!important",
              fontSize: "0.875rem!important",
              paddingX: 3,
              paddingY: 1,
              "&:hover": { backgroundColor: "#087654!important" },
            }}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} mt={2} sx={{ paddingLeft: 1 }}>
        <Grid item sm={12}>
          <WSDataGridNew
            columns={columns}
            id="technicianListGrid"
            title={`Technicians - ${selectedFilter} (${filteredTechnicians.length})`}
            exportCsv={true}
            data={filteredTechnicians}
            addButton={{ label: "New Technician", color: "secondary" }}
            onAddButtonClick={handleClick}
            searchBox={{ fieldName: "profileName" }}
            gridHeaderSx={{ backgroundColor: "whitesmoke", border: "1px solid whitesmoke" }}
          />
        </Grid>
      </Grid>

      {/* ✅ Drawer with SAVE BUTTON NOW VISIBLE */}
      <SwipeableDrawerForm 
        anchor="right" 
        title="Add New Technician"
        openForm={drawerOpen} 
        isEdit={false}  // ✅ Shows "Save" button
        id="technicianAdd"
        formComponent={formComponent}
        onClose={() => { 
          reset(); 
          setDrawerOpen(false); 
          setFormComponent(null); 
        }}
      />
    </>
  );
});

export default TechnicianManagement;
